/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Strikethrough({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M10.7 4.59A2.59 2.59 0 0 0 8.11 2h-.25A2.56 2.56 0 0 0 5.3 4.56c0 .813.37 1.58 1.005 2.087l.255.203h6.94a.6.6 0 1 1 0 1.2h-11a.6.6 0 0 1 0-1.2h2.35a3.869 3.869 0 0 1-.75-2.29A3.76 3.76 0 0 1 7.86.8h.25a3.79 3.79 0 0 1 3.79 3.79v.11a.6.6 0 1 1-1.2 0v-.11ZM11.85 9.6a.6.6 0 0 1 .6.6v.55a4.45 4.45 0 0 1-8.9 0v-.55a.6.6 0 0 1 1.2 0v.55a3.25 3.25 0 0 0 6.5 0v-.55a.6.6 0 0 1 .6-.6Z" /></svg>;
}
;